// extracted by mini-css-extract-plugin
module.exports = {"root":"BindTitle_root__qm3wn"};